<template>
  <div id="change-price-requests">
    <div class="p-6 loading-table" v-if="loading">
      <spinner-color />
    </div>

    <div v-else>
      <div class="mb-4">
        <vs-alert :active="!!errorMsg" color="danger" icon="new_releases">
          <span>{{ errorMsg }}</span>
        </vs-alert>
      </div>

      <div style="position: relative; width: 38%; margin-bottom: 20px;">
        <input
          v-model="search"
          @keyup.enter="doSearch()"
          @input="onSearchInput()"
          placeholder="ابحث هنا بكود الطلبية"
          class="search-mission w-full"
        />

        <i class="icon-advanced-search" @click="doSearch()">
          <vx-tooltip text="إضغط للبحث" delay="0.2s" position="bottom">
            <svg xmlns="http://www.w3.org/2000/svg" width="16.414" height="16.653" viewBox="0 0 16.414 16.653">
              <g id="search" transform="translate(1 1)">
                <circle cx="6" cy="6" r="6" fill="none" stroke="#6e6b7b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <line x1="3.469" y1="3.469" transform="translate(10.531 10.77)" fill="none" stroke="#6e6b7b" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </g>
            </svg>
          </vx-tooltip>
        </i>

        <i v-if="search" class="icon-reset-search" @click="resetSearch()">
          <vx-tooltip text="مسح البحث" delay="0.2s" position="bottom">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
              <line x1="1" y1="1" x2="13" y2="13" stroke="#6e6b7b" stroke-width="2" stroke-linecap="round"/>
              <line x1="13" y1="1" x2="1" y2="13" stroke="#6e6b7b" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </vx-tooltip>
        </i>

        <span class="err-search-msg" v-if="searchError">{{ searchError }}</span>
      </div>

      <vs-card>
        <div class="flex flex-wrap items-center justify-between w-full">
          <div>
            <feather-icon icon="DollarSignIcon" svgClasses="h-4 w-4"></feather-icon>
            <h3 class="font-bold mb-2 ml-3" style="display: inline-block; font-size: 1.125rem">
              طلبات تغيير السعر
            </h3>
          </div>

          <div class="flex items-center">
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-2 mr-2">
              <div
                style="font-family: 'Cairo', sans-serif !important; padding: 0.75rem !important; border-radius: 0.25rem !important;"
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2">عرض {{ perPage }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <ul style="min-width: 8rem">
                  <vs-dropdown-item @click="setPerPage(10)" class="m-0 p-0">
                    <li class="flex py-4 px-4 cursor-pointer profile-drop"><span>10</span></li>
                  </vs-dropdown-item>
                  <vs-divider class="m-0" />
                  <vs-dropdown-item @click="setPerPage(20)" class="m-0 p-0">
                    <li class="flex py-4 px-4 cursor-pointer profile-drop"><span>20</span></li>
                  </vs-dropdown-item>
                  <vs-divider class="m-0" />
                  <vs-dropdown-item @click="setPerPage(50)" class="m-0 p-0">
                    <li class="flex py-4 px-4 cursor-pointer profile-drop"><span>50</span></li>
                  </vs-dropdown-item>
                  <vs-divider class="m-0" />
                  <vs-dropdown-item @click="setPerPage(100)" class="m-0 p-0">
                    <li class="flex py-4 px-4 cursor-pointer profile-drop"><span>100</span></li>
                  </vs-dropdown-item>
                </ul>
              </vs-dropdown-menu>
            </vs-dropdown>

            <vs-button
              style="font-family: 'Cairo', sans-serif !important"
              type="border"
              color="primary"
              class="mb-2"
              :disabled="refreshing"
              @click="fetchRequests()"
            >
              تحديث
            </vs-button>
          </div>
        </div>

        <vs-divider class="m-0 mt-4" />

        <vs-table :data="requests" noDataText="">
          <template slot="thead">
            <vs-th>الكود</vs-th>
            <vs-th>المستلم</vs-th>
            <vs-th>المندوب</vs-th>
            <vs-th>محتوى الطرد</vs-th>
            <vs-th>المحافظة</vs-th>
            <vs-th>المنطقة</vs-th>
            <vs-th>السعر</vs-th>
            <vs-th>ملاحظات المندوب</vs-th>
            <vs-th>الأوامر</vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :key="tr.id" v-for="tr in data">
                <vs-td>
                  <router-link :to="'/OrderDetails/' + tr.order.code">
                    <p class="font-medium truncate code">{{ tr.order.code }}</p>
                  </router-link>
                </vs-td>
                <vs-td>
                  <p class="font-medium break-all" style="word-break: break-all; overflow-wrap: break-word;">
                    {{ tr.order.receiver || "-" }}
                  </p>
                  <p v-if="tr.order.phone1" class="text-sm text-grey mt-1">{{ tr.order.phone1 }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium">{{ (tr.captain && tr.captain.name) || "-" }}</p>
                  <p v-if="tr.captain && tr.captain.phone1" class="text-sm text-grey mt-1">{{ tr.captain.phone1 }}</p>
                </vs-td>
                <vs-td>
                  <p class="font-medium truncate">{{ tr.order.order_summary || "-" }}</p>
                  <span v-if="tr.partial_return" class="badge-partial">مرتجع جزئي</span>
                </vs-td>
                <vs-td><p class="font-medium truncate">{{ tr.order.government_name || "-" }}</p></vs-td>
                <vs-td><p class="font-medium truncate">{{ tr.order.area_name || "-" }}</p></vs-td>
                <vs-td>
                  <div class="price-cell">
                    <span class="old-price">{{ tr.order_amount }}</span>
                    <span class="price-arrow">←</span>
                    <span class="new-price">{{ tr.new_amount }}</span>
                  </div>
                </vs-td>
                <vs-td>
                  <p v-if="tr.captain_notes" class="captain-notes-text">
                    <feather-icon icon="MessageCircleIcon" svgClasses="h-3 w-3 text-warning" class="ml-1" />
                    {{ tr.captain_notes }}
                  </p>
                  <span v-else class="text-grey">-</span>
                </vs-td>
                <vs-td class="whitespace-no-wrap">
                  <vs-button
                    style="font-family: 'Cairo', sans-serif !important"
                    size="small" color="success" type="filled"
                    :disabled="actionLoadingId === tr.id || spin"
                    @click.stop="openConfirm(tr, true)"
                  >اوافق</vs-button>
                  <vs-button
                    style="font-family: 'Cairo', sans-serif !important"
                    size="small" color="danger" type="filled" class="ml-2"
                    :disabled="actionLoadingId === tr.id || spin"
                    @click.stop="openConfirm(tr, false)"
                  >لا اوافق</vs-button>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>

        <div v-if="pagination.last_page > 1" class="flex justify-center mt-4">
          <vs-pagination
            :total="pagination.last_page"
            v-model="currentPage"
          />
        </div>
      </vs-card>

      <vs-popup
        class="holamundo"
        :title="confirmAction ? 'تأكيد الموافقة' : 'تأكيد الرفض'"
        :active.sync="confirmActive"
        @close="resetConfirm()"
      >
        <p style="padding-bottom: 1rem">
          {{
            confirmAction
              ? `هل تريد الموافقة على تغيير سعر الطلب (${confirmRequest && confirmRequest.order ? confirmRequest.order.code : ''})?`
              : `هل تريد رفض تغيير سعر الطلب (${confirmRequest && confirmRequest.order ? confirmRequest.order.code : ''})?`
          }}
        </p>
        <vs-button
          style="font-family: 'Cairo', sans-serif !important"
          @click.stop="submitConfirm()"
          :color="confirmAction ? 'success' : 'danger'"
          class="mr-3" type="filled" :disabled="spin"
        >{{ confirmAction ? "موافق" : "رفض" }}</vs-button>
        <vs-button
          style="font-family: 'Cairo', sans-serif !important"
          @click="confirmActive = false"
          color="primary" type="filled" :disabled="spin"
        >إلغاء</vs-button>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SpinnerColor from "@/views/components/table-components/SpinnerColor2.vue";

export default {
  components: { SpinnerColor },

  data() {
    return {
      loading: true,
      refreshing: false,
      spin: false,
      errorMsg: "",
      searchError: "",
      requests: [],
      perPage: 15,
      currentPage: 1,
      pagination: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 1,
      },
      actionLoadingId: null,
      search: "",
      confirmActive: false,
      confirmAction: null,
      confirmRequest: null,
    };
  },

  watch: {
    "$route.query.code"(newCode) {
      this.search = newCode || "";
      this.currentPage = 1;
      this.fetchRequests();
    },
    currentPage(newPage) {
      this.fetchRequests(newPage);
    },
  },

  created() {
    if (this.$route.query.code) {
      this.search = this.$route.query.code;
    }
    this.fetchRequests();
  },

  methods: {
    onSearchInput() {
      if (!this.search) {
        this.resetSearch();
      }
    },

    doSearch() {
      this.searchError = "";
      const code = this.search.trim();
      if (!code) {
        this.resetSearch();
        return;
      }
      this.currentPage = 1;
      this.$router.replace({ query: { code } }).catch(() => {});
    },

    resetSearch() {
      this.search = "";
      this.searchError = "";
      this.currentPage = 1;
      this.$router.replace({ query: {} }).catch(() => {});
    },

    async fetchRequests(page) {
      this.errorMsg = "";
      this.searchError = "";
      this.refreshing = true;

      const params = {
        per_page: this.perPage,
        page: page || this.currentPage,
      };
      if (this.$route.query.code) {
        params.code = this.$route.query.code;
      }

      try {
        const { data } = await axios.get("order/get_order_change_requests", { params });

        if (data && data.success === 1) {
          this.requests = Array.isArray(data.order_change_requests) ? data.order_change_requests : [];
          if (data.pagination) {
            this.pagination = data.pagination;
            this.currentPage = data.pagination.current_page;
          }
          if (params.code && this.requests.length === 0) {
            this.searchError = "لا يوجد طرد بهذا الكود، تأكد من الكود وحاول مجدداً";
          }
        } else {
          this.requests = [];
          this.errorMsg = (data && data.message) || "حدث خطأ أثناء تحميل الطلبات";
        }
      } catch (err) {
        this.requests = [];
        const res = err && err.response && err.response.data ? err.response.data : null;
        this.errorMsg =
          (res && res.message ? res.message : "") ||
          (err && err.message ? err.message : "") ||
          "حدث خطأ أثناء تحميل الطلبات";
      } finally {
        this.loading = false;
        this.refreshing = false;
      }
    },

    setPerPage(value) {
      this.perPage = value;
      this.currentPage = 1;
      this.fetchRequests();
    },

    openConfirm(request, accept) {
      this.confirmRequest = request;
      this.confirmAction = accept;
      this.confirmActive = true;
    },

    resetConfirm() {
      if (this.spin) return;
      this.confirmActive = false;
      this.confirmAction = null;
      this.confirmRequest = null;
    },

    async submitConfirm() {
      if (this.confirmRequest === null || this.confirmAction === null) return;

      this.spin = true;
      this.actionLoadingId = this.confirmRequest.id;

      try {
        const { data } = await axios.post("order/process_order_change_requests", {
          order_id: this.confirmRequest.order_id,
          accept: this.confirmAction,
          partial_return: this.confirmRequest.partial_return,
          socket_id: this.$socket ? this.$socket.id : null,
        });

        if (data && data.success) {
          const removedId = this.confirmRequest.id;
          this.requests = this.requests.filter((r) => r.id !== removedId);
          this.confirmActive = false;
          this.resetConfirm();
          this.$vs.notify({
            title: "نجاح",
            text: data.message || (this.confirmAction ? "تم قبول تغيير السعر" : "تم رفض تغيير السعر"),
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
          });
        } else {
          this.$vs.notify({
            title: "خطأ",
            text: (data && data.message) || "حدث خطأ أثناء تنفيذ العملية",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-triangle",
          });
        }
      } catch (err) {
        const res = err && err.response && err.response.data ? err.response.data : null;
        this.$vs.notify({
          title: "خطأ",
          text: (res && res.message) || (err && err.message) || "تعذر الاتصال بالخادم",
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-octagon",
        });
      } finally {
        this.spin = false;
        this.actionLoadingId = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_loadingTable.scss";

.search-mission {
  width: 100%;
  height: 38px;
  border: 1px solid #D8D6DE;
  border-radius: 4px;
  padding: 0 2.2rem 0 2.2rem;
  color: #212121;
  margin-top: 15px;
  margin-bottom: 15px;
}

.icon-advanced-search {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
}

.icon-reset-search {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  opacity: 0.6;
  transition: opacity 0.2s;

  &:hover {
    opacity: 1;
  }
}

.err-search-msg {
  position: absolute;
  left: 5px;
  top: 100%;
  color: #ea5455;
  font-size: 1rem;
  font-weight: 500;
  margin-top: -10px;
  white-space: nowrap;
}

.price-cell {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
}

.old-price {
  color: #6e6b7b;
  font-weight: 500;
}

.price-arrow {
  color: #6e6b7b;
  font-size: 0.75rem;
}

.new-price {
  color: #ea5455;
  font-weight: 700;
}

.badge-partial {
  display: inline-block;
  margin-top: 4px;
  padding: 1px 6px;
  border-radius: 10px;
  background-color: #fff3cd;
  color: #856404;
  font-size: 0.7rem;
  font-weight: 600;
}

.captain-notes-text {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 0.8rem;
  color: #856404;
  background-color: #fff8e1;
  border-right: 3px solid #ffc107;
  padding: 3px 6px;
  border-radius: 4px;
  max-width: 200px;
  word-break: break-word;
}
</style>
